import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { CHANNEL_ROUTES } from './channels/channel-routes';
import { ADMIN_ROUTES } from './admin/admin-routes';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () =>
      import('./home/home.component').then((m) => m.HomeComponent),
    pathMatch: 'full',
  },
  ...ADMIN_ROUTES,
  {
    path: 'channels',
    loadComponent: () =>
      import('./channels/all-channels.component').then(
        (m) => m.AllChannelsComponent,
      ),
    pathMatch: 'full',
    canActivate: [MsalGuard],
    title: 'All Channels',
  },
  ...CHANNEL_ROUTES,
  {
    path: '**',
    redirectTo: 'channels',
    pathMatch: 'full',
  },
];
